import { useConfig } from "../authHooks";
import { redirectToProvider } from "../api_client/allauth";
import { isWebExtension } from "@sharpana/shared/utils/web_environment";
import GoogleSignInButton from "./GoogleSignInButton";
import AppleSignInButton from "./AppleSignInButton";
import { webLoginButtons } from "./webLoginButtons";
import { useMemo } from "react";

export default function ProviderList(props: any) {
  const config = useConfig();
  const providers = config.data.socialaccount.providers;
  // One button per provider id, Google above Apple — see webLoginButtons for
  // why the id, and not an app's client id, is what makes two entries the
  // same button. Computed before the early return: a hook called after one
  // runs on some renders and not others, which React rejects.
  const buttons = useMemo(() => webLoginButtons<any>(providers), [providers]);
  if (!buttons.length) {
    return null;
  }

  const flowDescription = props.flowDescription
    ? props.flowDescription
    : "Sign in";

  const openLoginPopup = (providerId: string) => {
    // alert('clicked')
    const popupWinWidth: any = "460";
    const popupWinHeight: any = "650";
    // eslint-disable-next-line no-restricted-globals
    let left = (screen.width - popupWinWidth) / 2;
    // eslint-disable-next-line no-restricted-globals
    let top = (screen.height - popupWinHeight) / 4;
    const windowFeatures =
      "left=" +
      left +
      ",top=" +
      top +
      ",width=" +
      popupWinWidth +
      ",height=" +
      popupWinHeight;
    const handle = window.open(
      `/account/login-web-extension/provider/popup/${providerId}`,
      "social-login-popup",
      windowFeatures
    );
    if (!handle) {
      // The window wasn't allowed to open
      // This is likely caused by built-in popup blockers.
      // …
    }
  };

  const isOnWebExtension = isWebExtension();

  const handleOnClick = (providerId: string) => {
    if (isOnWebExtension) {
      openLoginPopup(providerId); // web extension runs inside an iframe, most providers don't work inside iframes
    } else {
      redirectToProvider(providerId, props.callbackURL, props.process);
    }
  };

  return (
    <>
      {buttons.map((provider: any) => {
        return (
          <div key={provider.id}>
            <div onClick={() => handleOnClick(provider.id)}>
              {provider.name == "Google" ? (
                <GoogleSignInButton text={flowDescription} />
              ) : provider.name == "Apple" ? (
                <AppleSignInButton text={flowDescription} />
              ) : (
                <>{provider.name}</>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}
